import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconsTextComponent } from './icons-text.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [IconsTextComponent],
  exports: [
    IconsTextComponent
  ]
})
export class IconsTextModule { }
